import { useSuspenseQuery } from "@tanstack/react-query";

import { getTerritoryControlledList } from "./territoryControlledList.service";
import { QUERY_KEYS } from "../queryKeys";

export const useGetTerritoryControlledListQuery = () => {
  return useSuspenseQuery({
    queryKey: [QUERY_KEYS.territoryControlledList],
    queryFn: () => getTerritoryControlledList(),
  });
};
